import type VapidPublicKeyDto from '@/models/dto/push/VapidPublicKeyDto';

export default class VapidPublicKeyResource {
  /** Chave pública VAPID em base64url, no formato aceito por `applicationServerKey` depois de decodificada. */
  chavePublica: string;

  constructor(dto: VapidPublicKeyDto) {
    if (!dto.chavePublica) {
      throw new Error('Chave pública VAPID ausente na resposta do serviço de push');
    }
    this.chavePublica = dto.chavePublica;
  }
}
